import toast from 'react-hot-toast';
import Axios from '../utils/Axios';
import {useNavigate } from 'react-router-dom';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';

const Register = () => {
    const navigate = useNavigate();
    const sendCredentials = async (credential) => {
        try {
            const user = await axios.get(`https://oauth2.googleapis.com/tokeninfo?id_token=${credential}`);
            const userData = {
                name: user.data.name,
                email: user.data.email,
            }
            console.log("userData", userData);
            const response = await Axios.post(`api/user/register`, userData);

            console.log("Response", response.data);
            if (response.data.error) {
                toast.error(response.data.message);
            }

            if (response.data.success) {
                toast.success(response.data.message);
                navigate("/");
            }
        } catch (error) {
            console.error(error);
        }
    }
    
    return (
        <GoogleOAuthProvider clientId="353791268185-4h0sgotgr2r3psvr7bq678vf8nsnhrcn.apps.googleusercontent.com">
        <div>
            <h1>Registration Page</h1>
            <p>This is the registration page.</p>
            <GoogleLogin
              onSuccess={credentialResponse => {
                  console.log(credentialResponse.credential);
                  sendCredentials(credentialResponse.credential);
              }}
              onError={() => {
                  console.log('Login Failed');
                  toast.error('Login Failed');
              }}
            />
        </div>
        </GoogleOAuthProvider>
    );
};

export default Register;